/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitlementsRelation} from '../models/UpdateEntitlementsRelation';

export interface BulkProductDischargeAccountEntitlements$Request {
    updateEntitlementsRelation: UpdateEntitlementsRelation;
    reason?: string;
}

export interface BulkProductDischargeAccountEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkProductDischargeAccountEntitlementsRequest = createAction<PayloadData<void, BulkProductDischargeAccountEntitlements$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__REQUEST');
export const bulkProductDischargeAccountEntitlementsSuccess = createAction<PayloadData<string, BulkProductDischargeAccountEntitlements$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__SUCCESS');
export const bulkProductDischargeAccountEntitlementsFailure = createAction<PayloadData<Error, BulkProductDischargeAccountEntitlements$Request, true>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__FAILURE');

export const bulkProductDischargeAccountEntitlementsActions = [
    bulkProductDischargeAccountEntitlementsRequest,
    bulkProductDischargeAccountEntitlementsSuccess,
    bulkProductDischargeAccountEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitlementsRelation} meta.updateEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkProductDischargeAccountEntitlements = (meta: BulkProductDischargeAccountEntitlements$Request, config?: BulkProductDischargeAccountEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkProductDischargeAccountEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductDischargeAccountEntitlementsProgress$Request {
    id: string;
}

export interface GetProductDischargeAccountEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductDischargeAccountEntitlementsProgressRequest = createAction<PayloadData<void, GetProductDischargeAccountEntitlementsProgress$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__REQUEST');
export const getProductDischargeAccountEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetProductDischargeAccountEntitlementsProgress$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getProductDischargeAccountEntitlementsProgressFailure = createAction<PayloadData<Error, GetProductDischargeAccountEntitlementsProgress$Request, true>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_PROGRESS__FAILURE');

export const getProductDischargeAccountEntitlementsProgressActions = [
    getProductDischargeAccountEntitlementsProgressRequest,
    getProductDischargeAccountEntitlementsProgressSuccess,
    getProductDischargeAccountEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductDischargeAccountEntitlementsProgress = (meta: GetProductDischargeAccountEntitlementsProgress$Request, config?: GetProductDischargeAccountEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductDischargeAccountEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/accounts/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductDischargeAccountEntitlementsResult$Request {
    id: string;
}

export interface GetProductDischargeAccountEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductDischargeAccountEntitlementsResultRequest = createAction<PayloadData<void, GetProductDischargeAccountEntitlementsResult$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__REQUEST');
export const getProductDischargeAccountEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetProductDischargeAccountEntitlementsResult$Request>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__SUCCESS');
export const getProductDischargeAccountEntitlementsResultFailure = createAction<PayloadData<Error, GetProductDischargeAccountEntitlementsResult$Request, true>>('BULK_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_ACCOUNT_ENTITLEMENTS_RESULT__FAILURE');

export const getProductDischargeAccountEntitlementsResultActions = [
    getProductDischargeAccountEntitlementsResultRequest,
    getProductDischargeAccountEntitlementsResultSuccess,
    getProductDischargeAccountEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductDischargeAccountEntitlementsResult = (meta: GetProductDischargeAccountEntitlementsResult$Request, config?: GetProductDischargeAccountEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductDischargeAccountEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/accounts/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

